import { render, staticRenderFns } from "./AddMNinformation.vue?vue&type=template&id=cacbcf82&scoped=true&"
import script from "./AddMNinformation.vue?vue&type=script&lang=js&"
export * from "./AddMNinformation.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tablecss.less?vue&type=style&index=0&id=cacbcf82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacbcf82",
  null
  
)

export default component.exports